<app-nav-red-logo></app-nav-red-logo>

<main>
  <app-projects-slider></app-projects-slider>
</main>

<app-footer class="w-100 d-none d-sm-block"></app-footer>
<app-footer-sm  class="w-100 d-sm-none"></app-footer-sm>